<div *ngIf="isVisible" class="kyc-banner" [attr.data-variant]="config.variant">
  <div class="kyc-banner__icon">
    <mat-icon>{{ config.icon }}</mat-icon>
  </div>

  <div class="kyc-banner__body">
    <div class="kyc-banner__title">{{ config.title }}</div>
    <div class="kyc-banner__subtitle">{{ config.subtitle }}</div>
    <div class="kyc-banner__meta" *ngIf="snap?.kycReferenceNumber">
      Reference: <strong>{{ snap?.kycReferenceNumber }}</strong>
    </div>
  </div>

  <button
    *ngIf="config.ctaLabel"
    class="kyc-banner__cta"
    mat-flat-button
    (click)="goToKyc()"
  >
    {{ config.ctaLabel }}
    <mat-icon class="kyc-banner__cta-icon">arrow_forward</mat-icon>
  </button>
</div>
